export default __webpack_public_path__ + "static/media/Omkar.3ff44c85.ogg";